export class GenericdatasetSettings {
   public static get api_endpoint(): string { return 'http://www.odusseuserp.org/api/'; }
   //public static get api_endpoint(): string { return 'http://api.sitarm.com/'; }
   //public static get api_endpoint(): string { return 'http://localhost:3000/api/'; }
}
